<div class="dashboard-container" [class.sidebar-collapsed]="isSidebarCollapsedDesktop">
  <div class="sidebar-backdrop" [class.visible]="isSidebarOpen" (click)="toggleSidebar()"></div>

  <aside class="sidebar" [class.open]="isSidebarOpen">
    <!-- Accordion menu: visible on mobile and desktop expanded -->
    <ul class="sidebar-menu">
      <ng-template #recursiveMenu let-items>
        <li *ngFor="let item of items">
          <a (click)="handleMenuClick(item)" [class.expanded]="item.expanded">
            <i class="bi {{ getMenuIcon(item) }} menu-icon"></i>
            <span class="menu-text">{{ item.title }}</span>
            <i *ngIf="item.children && item.children.length > 0"
               class="bi menu-arrow"
               [class.bi-chevron-down]="!item.expanded"
               [class.bi-chevron-up]="item.expanded"></i>
          </a>
          <ul *ngIf="item.children && item.children.length > 0"
              class="sub-menu"
              [@accordion]="item.expanded ? 'expanded' : 'collapsed'">
            <ng-container *ngTemplateOutlet="recursiveMenu; context: { $implicit: item.children }"></ng-container>
          </ul>
        </li>
      </ng-template>
      <ng-container *ngTemplateOutlet="recursiveMenu; context: { $implicit: processedMenuItems }"></ng-container>
    </ul>

    <!-- Icon strip: visible only on desktop collapsed -->
    <ul class="sidebar-icon-strip">
      <li *ngFor="let item of processedMenuItems" class="icon-strip-item">
        <a (click)="handleMenuClick(item)" [title]="item.title" class="icon-strip-link">
          <i class="bi {{ getMenuIcon(item) }}"></i>
        </a>
        <div *ngIf="item.children && item.children.length > 0" class="icon-flyout">
          <div class="icon-flyout-title">{{ item.title }}</div>
          <ul>
            <li *ngFor="let child of item.children">
              <a (click)="handleMenuClick(child)">{{ child.title }}</a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </aside>

  <header class="header d-flex align-items-center justify-content-between px-4">

    <div class="header-brand">
      <button
        type="button"
        class="menu-toggle btn btn-icon btn-active-light-dark w-35px h-35px"
        (click)="toggleSidebar()"
        aria-label="Abrir menu">
        <span class="svg-icon svg-icon-2">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 5H20A1 1 0 0 1 20 7H4A1 1 0 0 1 4 5Z" fill="#FFFFFF" />
            <path d="M4 11H20A1 1 0 0 1 20 13H4A1 1 0 0 1 4 11Z" fill="#FFFFFF" />
            <path d="M4 17H20A1 1 0 0 1 20 19H4A1 1 0 0 1 4 17Z" fill="#FFFFFF" />
          </svg>
        </span>
      </button>

      <button
        type="button"
        class="desktop-sidebar-toggle btn btn-icon btn-active-light-dark w-35px h-35px"
        (click)="toggleDesktopSidebar()"
        [attr.aria-label]="isSidebarCollapsedDesktop ? 'Mostrar menu lateral' : 'Ocultar menu lateral'"
        [title]="isSidebarCollapsedDesktop ? 'Mostrar menu lateral' : 'Ocultar menu lateral'">
        <span class="svg-icon svg-icon-2">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 5H20A1 1 0 0 1 20 7H4A1 1 0 0 1 4 5Z" fill="#FFFFFF" />
            <path d="M4 11H20A1 1 0 0 1 20 13H4A1 1 0 0 1 4 11Z" fill="#FFFFFF" />
            <path d="M4 17H20A1 1 0 0 1 20 19H4A1 1 0 0 1 4 17Z" fill="#FFFFFF" />
          </svg>
        </span>
      </button>

      <div class="brand">
        <span class="brand-name">KALI ERP</span>
        <span class="brand-tagline">Gestão inteligente</span>
      </div>
    </div>

    <div class="d-flex gap-2">

      
      <button 
              type="button" 
              class="btn btn-icon btn-active-light-dark w-35px h-35px" 
              (click)="vendaBalcao()"
              aria-label="Nova Venda Balcão"
              title="Venda Balcão">
              
              <span class="svg-icon svg-icon-2"> 
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#FFFFFF" class="bi bi-cart-plus" viewBox="0 0 16 16">
              <path d="M9 5.5a.5.5 0 0 0-1 0V7H6.5a.5.5 0 0 0 0 1H8v1.5a.5.5 0 0 0 1 0V8h1.5a.5.5 0 0 0 0-1H9z"/>
              <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zm3.915 10L3.102 4h10.796l-1.313 7zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
            </svg>
              </span>
        </button>



        <button 
              type="button" 
              class="btn btn-icon btn-active-light-dark w-35px h-35px" 
              (click)="leadsModal()"
              aria-label="Registrar Novo Lead"
              title="Novo Lead">
              
              <span class="svg-icon svg-icon-2"> 
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.0149 13.1028C18.0859 13.1028 19.7649 11.4238 19.7649 9.35281C19.7649 7.28181 18.0859 5.60281 16.0149 5.60281C13.9439 5.60281 12.2649 7.28181 12.2649 9.35281C12.2649 11.4238 13.9439 13.1028 16.0149 13.1028Z" fill="#FFFFFF" />
                  <path opacity="0.3" d="M11.7859 21.2028H4.28589C3.78589 21.2028 3.28589 20.8028 3.28589 20.2028C3.28589 17.7028 5.28589 15.7028 7.78589 15.7028H10.2859C12.7859 15.7028 14.7859 17.7028 14.7859 20.2028C14.7859 20.8028 14.2859 21.2028 13.7859 21.2028H11.7859Z" fill="#FFFFFF" />
                  <rect x="18" y="15" width="2" height="6" rx="1" fill="#FFFFFF" />
                  <rect x="16" y="17" width="6" height="2" rx="1" fill="#FFFFFF" />
                </svg>
              </span>
        </button>
        

        <button 
          type="button"
          class="btn btn-icon btn-active-light-dark w-35px h-35px" 
          (click)="userModal()"
          aria-label="Open Apps Menu">
          <span class="svg-icon svg-icon-2">
         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 2H9C10.1046 2 11 2.89543 11 4V9C11 10.1046 10.1046 11 9 11H4C2.89543 11 2 10.1046 2 9V4C2 2.89543 2.89543 2 4 2Z" fill="#FFFFFF" />
              <path opacity="0.3" d="M15 2H20C21.1046 2 22 2.89543 22 4V9C22 10.1046 21.1046 11 20 11H15C13.8954 11 13 10.1046 13 9V4C13 2.89543 13.8954 2 15 2Z" fill="#FFFFFF" />
              <path d="M15 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22H15C13.8954 22 13 21.1046 13 20V15C13 13.8954 13.8954 13 15 13Z" fill="#FFFFFF" />
              <path d="M4 13H9C10.1046 13 11 13.8954 11 15V20C11 21.1046 10.1046 22 9 22H4C2.89543 22 2 21.1046 2 20V15C2 13.8954 2.89543 13 4 13Z" fill="#FFFFFF" />
            </svg>
          </span>
        </button>
    </div>

  </header>

  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>







<app-user-modal [isOpen]="isUserModalOpen" (closeModal)="userModal()"></app-user-modal>
<app-lead-modal [isOpen]="isLeadModalOpen" (closeModal)="leadsModal()"></app-lead-modal>
<app-venda-balcao-cupom-modal [isOpen]="isVendaBalcaoOpen" (closeModal)="closeVendaBalcao($event)"></app-venda-balcao-cupom-modal>
